import { render } from "./ActivityProperty.vue?vue&type=template&id=6dcc0bf0"
import script from "./ActivityProperty.vue?vue&type=script&lang=js"
export * from "./ActivityProperty.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__